import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryFetchFailedAction = {
	type: 'BENEFICIARY_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryFetchFailedAction => ({
	type: 'BENEFICIARY_FETCH_FAILED',
	payload,
});
